var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarkerCineDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 63.162,
    viewBox: "0 0 56 63.162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0070cc;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_822",
    "data-name": "Grupo 822",
    transform: "translate(-1176 -1023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_26",
    "data-name": "Trazado 26",
    className: "cls-1",
    d: "M5.611,0l5.611,8.843H0L1.5,6.477Z",
    transform: "translate(1211.029 1086.162) rotate(180)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_14",
    "data-name": "Elipse 14",
    className: "cls-1",
    cx: 28,
    cy: 28,
    r: 28,
    transform: "translate(1176 1023)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_252",
    "data-name": "Rect\\xE1ngulo 252",
    className: "cls-2",
    width: 19,
    height: 21,
    rx: 2,
    transform: "translate(1195 1040)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_253",
    "data-name": "Rect\\xE1ngulo 253",
    className: "cls-1",
    width: 7,
    height: 4,
    transform: "translate(1201 1039)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_273",
    "data-name": "Rect\\xE1ngulo 273",
    className: "cls-1",
    width: 7,
    height: 10,
    transform: "translate(1201 1046)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_254",
    "data-name": "Rect\\xE1ngulo 254",
    className: "cls-1",
    width: 7,
    height: 4,
    transform: "translate(1201 1059)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_255",
    "data-name": "Rect\\xE1ngulo 255",
    className: "cls-1",
    width: 2,
    height: 2,
    transform: "translate(1197 1044)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_264",
    "data-name": "Rect\\xE1ngulo 264",
    className: "cls-1",
    width: 2,
    height: 2,
    transform: "translate(1197 1040)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_266",
    "data-name": "Rect\\xE1ngulo 266",
    className: "cls-1",
    width: 2,
    height: 2,
    transform: "translate(1197 1048)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_268",
    "data-name": "Rect\\xE1ngulo 268",
    className: "cls-1",
    width: 2,
    height: 2,
    transform: "translate(1197 1052)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_270",
    "data-name": "Rect\\xE1ngulo 270",
    className: "cls-1",
    width: 2,
    height: 2,
    transform: "translate(1197 1056)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_272",
    "data-name": "Rect\\xE1ngulo 272",
    className: "cls-1",
    width: 2,
    height: 1,
    transform: "translate(1197 1060)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_262",
    "data-name": "Rect\\xE1ngulo 262",
    className: "cls-1",
    width: 2,
    height: 2,
    transform: "translate(1210 1044)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_263",
    "data-name": "Rect\\xE1ngulo 263",
    className: "cls-1",
    width: 2,
    height: 2,
    transform: "translate(1210 1040)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_265",
    "data-name": "Rect\\xE1ngulo 265",
    className: "cls-1",
    width: 2,
    height: 2,
    transform: "translate(1210 1048)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_267",
    "data-name": "Rect\\xE1ngulo 267",
    className: "cls-1",
    width: 2,
    height: 2,
    transform: "translate(1210 1052)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_269",
    "data-name": "Rect\\xE1ngulo 269",
    className: "cls-1",
    width: 2,
    height: 2,
    transform: "translate(1210 1056)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_271",
    "data-name": "Rect\\xE1ngulo 271",
    className: "cls-1",
    width: 2,
    height: 1,
    transform: "translate(1210 1060)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerCineDefault);
export default __webpack_public_path__ + "static/media/marker-cine-default.8028bf2f.svg";
export { ForwardRef as ReactComponent };